import { jwtDecode } from 'jwt-decode';
const useDashboard = () => {
	const SUPERSET_CACHE_KEY = "SUPERSET_CACHE";

	function getCache() {
		  const cached = sessionStorage.getItem(SUPERSET_CACHE_KEY);
		  return cached ? JSON.parse(cached) : {};
	  }

	  function setCache(cache) {
		  sessionStorage.setItem(SUPERSET_CACHE_KEY, JSON.stringify(cache));
	  }

	  function updateTabCache(tabId, data) {
		const cache = getCache();
		cache[tabId] = data;
		setCache(cache);
		return data
	  }

	  	function getTokenExpiration(token) {
			try {
				if (!token) {
					return 0;
				}
				const decoded = jwtDecode(token);
				return decoded.exp * 1000;
			} catch (error) {
				console.error('Error decoding token', error.message);
				return 0;
			}
		}

		const isCacheValid = (tabId) => {
			const cachedTab = getCache();
			const token = cachedTab[tabId]?.guestToken;
			return !!token && getTokenExpiration(token) >= Date.now();
		  };

	  return {
		getCache, setCache,updateTabCache, isCacheValid
	  }
}

export default useDashboard
